import { render, staticRenderFns } from "./test-add.vue?vue&type=template&id=6a58a9e6&scoped=true&"
import script from "./test-add.vue?vue&type=script&lang=js&"
export * from "./test-add.vue?vue&type=script&lang=js&"
import style0 from "./test-add.vue?vue&type=style&index=0&id=6a58a9e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a58a9e6",
  null
  
)

export default component.exports